import "./Aside.css";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

const Aside = () => {
  const [aside, setAside] = useState(true);

  const smoothScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const toggleAside = () => {
    setAside(!aside);
  };

  return (
    <>
      {aside && (
        <div className="aside-wrapper">
          <div className="aside">
            <a className="aside1">
              <div className="link1" onClick={toggleAside}>
                <CloseIcon />
              </div>
              <div className="link-wrapper">
                <div className="logo-title-frame">
                  <img
                    className="project-logo"
                    alt=""
                    src="/project-logo.png"
                  />
                  <h3 className="project-name">Forex Miner</h3>
                </div>
              </div>
              <div className="sub-container">
                <div className="item-link-parent">
                  <div
                    className="item-link"
                    onClick={() => {
                      toggleAside();
                      smoothScrollTo("hero");
                    }}
                  >
                    <a className="home">Home</a>
                  </div>
                  <div
                    className="item-link"
                    onClick={() => {
                      toggleAside();
                      smoothScrollTo("packages");
                    }}
                  >
                    <a className="feature">Packages</a>
                  </div>
                  <div
                    className="item-link"
                    onClick={() => {
                      toggleAside();
                      smoothScrollTo("faq");
                    }}
                  >
                    <a className="team">FAQ</a>
                  </div>
                  <div
                    className="item-link"
                    onClick={() => {
                      toggleAside();
                      smoothScrollTo("contact");
                    }}
                  >
                    <a className="team">Contact Us</a>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Aside;
